import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { Container } from 'react-bootstrap';
import { IoSettingsOutline } from 'react-icons/io5';
import { LuDollarSign } from 'react-icons/lu';

import { isFeatureEnabled } from 'helpers';
import { Tabs } from '_components/_core';

import { ChargesList, CompanyGateways } from './components';

function Charges({
  activeCompany,
  onFetchCharges,
  onFetchPaymentGateways,
  onFetchContacts,
  user,
}) {
  const [activeTab, setActiveTab] = useState('CHARGES');

  useEffect(() => {
    onFetchCharges();
    onFetchPaymentGateways();
    onFetchContacts();
  }, [onFetchCharges, onFetchPaymentGateways, onFetchContacts, activeCompany]);

  const getTabs = useCallback(() => {
    const tabs = [
      {
        id: 'CHARGES',
        title: 'Cobranças',
        icon: <LuDollarSign className="mr-2" />,
        className: 'tab-income',
        color: 'success',
        content: activeTab === 'CHARGES' && <ChargesList />,
      },
      {
        id: 'COMPANY_GATEWAYS',
        title: 'Configurações',
        icon: <IoSettingsOutline className="mr-2" />,
        iconSide: 'right',
        content: activeTab === 'COMPANY_GATEWAYS' && <CompanyGateways />,
      },
    ];

    return tabs;
  }, [activeTab]);

  if (!isFeatureEnabled('charges', user.flags)) {
    return null;
  }

  return (
    <Container fluid className="content-wrapper">
      <ReactTooltip />
      <Tabs
        floatRightLastTab
        variant="secondary"
        tabs={getTabs()}
        activeTab={activeTab}
        onTabChange={tab => {
          setActiveTab(tab);
        }}
      />
    </Container>
  );
}

Charges.defaultProps = {
  isCompact: false,
  charges: [],
  paymentGateways: [],
  paymentMethods: [],
  paymentMethodGateways: [],
  recipients: [],
};

Charges.propTypes = {
  activeCompany: PropTypes.object,
  charges: PropTypes.array,
  isLoading: PropTypes.bool,
  onFetchCharges: PropTypes.func.isRequired,
  onCreateCharge: PropTypes.func.isRequired,
  onEditCharge: PropTypes.func.isRequired,
  onDeleteCharge: PropTypes.func.isRequired,
  isCompact: PropTypes.bool,
  paymentGateways: PropTypes.array,
  adminPaymentGateways: PropTypes.array,
  paymentMethods: PropTypes.array,
  paymentMethodGateways: PropTypes.array,
  recipients: PropTypes.array,

  onFetchPaymentGateways: PropTypes.func.isRequired,
  onFetchPaymentMethods: PropTypes.func.isRequired,
  onFetchPaymentMethodGateway: PropTypes.func.isRequired,
  onCreatePaymentGateway: PropTypes.func.isRequired,
  onUpdatePaymentGateway: PropTypes.func.isRequired,
  onDeletePaymentGateway: PropTypes.func.isRequired,

  onFetchContacts: PropTypes.func.isRequired,
};

export default Charges;
